import React from "react";
import { Divider, Text } from "@mantine/core";
import SRD_Header from "components/Header";
import SRD_Navbar from "components/Navbar";
import styled from "styled-components";

function Layout({ children, title }) {
  return (
    <S.Container>
      <SRD_Header />
      <S.ContentWrapper>
        <SRD_Navbar />
        <S.Content>
          <Text fz="lg" fw={600}>
            {title}
          </Text>
          <Divider my="xs" />
          {children}
        </S.Content>
      </S.ContentWrapper>
    </S.Container>
  );
}

export default Layout;

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    height: 98vh;
  `,
  ContentWrapper: styled.div`
    display: flex;
    flex: 1;
  `,
  Content: styled.div`
    flex: 1;
    padding: 20px;
  `,
};
